<div class="about bg-base-100">
  <div class="hero w-full h-70  flex-row justify-items-start"
    style="background-image: url('images/aboutPage/theater-chair.png');">
    <div class="hero-overlay bg-neutral-800 opacity-80"></div>
    <div class="hero-content px-10">
      <h1
        class="w-full font-heading text-balance font-bold text-[40px] text-left  bg-gradient-to-r from-primary  to-accent bg-clip-text text-transparent">
        About Us</h1>
    </div>
  </div>
  <div class="p-10 text-neutral bg-base-200 mx-6 my-10 rounded-2xl ">
      <h2 class="text-[30px]  font-bold text-primary ">BlockBuster <span>&#8210;</span> Best Place for Movies</h2>
      <p class="mt-3.5">Welcome to Blockbuster, your ultimate destination for everything cinema!
        At Blockbuster, we are passionate about movies and aim to provide a
        platform where movie enthusiasts</p>
      <p>
        Indulge in the joy of cinema with our curated collections, featuring handpicked movies grouped by themes,
        directors, or actors. Dive into the world of cinematic magic and let
        yourself be transported to new realms of imagination and emotion.
      </p>
  </div>
  <!-- grid view of 3 col ..............................................-->
  <div
    class="p-10 text-neutral bg-base-200 mx-6 my-10 rounded-2xl ">
    <div class="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 ">
      <div class="flex flex-row items-start text-center">
        <div
          class="rounded-xl p-3 bg-primary  text-neutral-50  transition-all duration-200 ease-in  hover:bg-base-200 border-2 border-primary hover:text-primary ">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor" class="w-10 h-10 ">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 0 1-1.125-1.125M3.375 19.5h1.5C5.496 19.5 6 18.996 6 18.375m-3.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-1.5A1.125 1.125 0 0 1 18 18.375M20.625 4.5H3.375m17.25 0c.621 0 1.125.504 1.125 1.125M20.625 4.5h-1.5C18.504 4.5 18 5.004 18 5.625m3.75 0v1.5c0 .621-.504 1.125-1.125 1.125M3.375 4.5c-.621 0-1.125.504-1.125 1.125M3.375 4.5h1.5C5.496 4.5 6 5.004 6 5.625m-3.75 0v1.5c0 .621.504 1.125 1.125 1.125m0 0h1.5m-1.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m1.5-3.75C5.496 8.25 6 7.746 6 7.125v-1.5M4.875 8.25C5.496 8.25 6 8.754 6 9.375v1.5m0-5.25v5.25m0-5.25C6 5.004 6.504 4.5 7.125 4.5h9.75c.621 0 1.125.504 1.125 1.125m1.125 2.625h1.5m-1.5 0A1.125 1.125 0 0 1 18 7.125v-1.5m1.125 2.625c-.621 0-1.125.504-1.125 1.125v1.5m2.625-2.625c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125M18 5.625v5.25M7.125 12h9.75m-9.75 0A1.125 1.125 0 0 1 6 10.875M7.125 12C6.504 12 6 12.504 6 13.125m0-2.25C6 11.496 5.496 12 4.875 12M18 10.875c0 .621-.504 1.125-1.125 1.125M18 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m-12 5.25v-5.25m0 5.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125m-12 0v-1.5c0-.621-.504-1.125-1.125-1.125M18 18.375v-5.25m0 5.25v-1.5c0-.621.504-1.125 1.125-1.125M18 13.125v1.5c0 .621.504 1.125 1.125 1.125M18 13.125c0-.621.504-1.125 1.125-1.125M6 13.125v1.5c0 .621-.504 1.125-1.125 1.125M6 13.125C6 12.504 5.496 12 4.875 12m-1.5 0h1.5m-1.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M19.125 12h1.5m0 0c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h1.5m14.25 0h1.5" />
          </svg>
        </div>
        <div class="text-left px-5">
          <p class="text-primary mb-1 text-[20px]">Top Movies</p>
          <p class="text-text-neutral">Discover new releases and timeless classics.</p>
        </div>
      </div>

      <div class="flex flex-row items-start text-center ">
        <div
          class="rounded-xl p-3 bg-primary  text-neutral-50  transition-all duration-200 ease-in  hover:bg-base-200 border-2 border-primary hover:text-primary">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor" class="w-10 h-10 ">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M20.25 6.375c0 2.278-3.694 4.125-8.25 4.125S3.75 8.653 3.75 6.375m16.5 0c0-2.278-3.694-4.125-8.25-4.125S3.75 4.097 3.75 6.375m16.5 0v11.25c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125V6.375m16.5 0v3.75m-16.5-3.75v3.75m16.5 0v3.75C20.25 16.153 16.556 18 12 18s-8.25-1.847-8.25-4.125v-3.75m16.5 0c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125" />
          </svg>

        </div>
        <div class="text-left px-5">
          <p class="text-primary mb-1 text-[20px]">Large Database Of Series</p>
          <p class="text-neutral">Explore a wide range of movies across different genres.</p>
        </div>
      </div>

      <div class="flex flex-row items-start text-center ">
        <div
          class="rounded-xl p-3 bg-primary  text-neutral-50  transition-all duration-200 ease-in  hover:bg-base-200 border-2 border-primary hover:text-primary">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor" class="w-10 h-10 ">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M15 9h3.75M15 12h3.75M15 15h3.75M4.5 19.5h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Zm6-10.125a1.875 1.875 0 1 1-3.75 0 1.875 1.875 0 0 1 3.75 0Zm1.294 6.336a6.721 6.721 0 0 1-3.17.789 6.721 6.721 0 0 1-3.168-.789 3.376 3.376 0 0 1 6.338 0Z" />
          </svg>

        </div>
        <div class="text-left px-5">
          <p class="text-primary mb-1 text-[20px]">Cinephiles Reviews</p>
          <p class="text-neutral">Read detailed movie summaries, ratings, and reviews.</p>
        </div>
      </div>

      <!-- </div> -->

      <div class="flex flex-row items-start text-center ">
        <div
          class="rounded-xl p-3 bg-primary  text-neutral-50  transition-all duration-200 ease-in  hover:bg-base-200 border-2 border-primary hover:text-primary">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor" class="w-10 h-10  ">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="m15.75 10.5 4.72-4.72a.75.75 0 0 1 1.28.53v11.38a.75.75 0 0 1-1.28.53l-4.72-4.72M4.5 18.75h9a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25h-9A2.25 2.25 0 0 0 2.25 7.5v9a2.25 2.25 0 0 0 2.25 2.25Z" />
          </svg>

        </div>
        <div class="text-left px-5">
          <p class="text-primary mb-1 text-[20px]">Free Movies</p>
          <p class="text-neutral">Watching new free tvShows anytime you want.</p>
        </div>
      </div>

      <div class="flex flex-row items-start text-center  ">
        <div
          class="rounded-xl p-3 bg-primary  text-neutral-50  transition-all duration-200 ease-in  hover:bg-base-200 border-2 border-primary hover:text-primary">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor" class="w-10 h-10  ">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z" />
          </svg>
        </div>
        <div class="text-left px-5">
          <p class="text-primary mb-1 text-[20px]">Security</p>
          <p class="text-neutral">Permissins for users to Autherization Process or Payment Process.</p>
        </div>
      </div>

      <div class="flex flex-row items-start text-center ">
        <div
          class="rounded-xl p-3 bg-primary  text-neutral-50  transition-all duration-200 ease-in  hover:bg-base-200 border-2 border-primary hover:text-primary">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor" class="w-10 h-10 ">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
          </svg>
        </div>
        <div class="text-left px-5">
          <p class="text-primary mb-1 text-[20px]">Plans</p>
          <p class="text-neutral">Subscribe in plans Premier or Free plans .</p>
        </div>
      </div>

    </div>



  </div>
  <div
    class="p-10 text-neutral bg-base-200 mx-6 my-10 rounded-2xl ">
    <h2
      class="w-full  font-bold text-[30px] text-left bg-gradient-to-r from-primary via-accent to-secondary bg-clip-text text-transparent">
      How It Use the Site </h2>
    <div class="my-8 grid  grid-cols-1 sm:grid-cols-1 lg:grid-cols-3 md:grid-cols-2 gap-4 ">
      <div
        class="flex flex-col items-start  border-2 border-base-100 p-5 rounded-3xl transition-all duration-200 ease-in-out hover:bg-base-100">
        <p class="text-[30px] text-primary font-bold mb-4">01</p>
        <p class="text-[20px]  font-bold text-accent mb-4">Create Your Account</p>
        <p class="text-[18px] text-neutral-400 mb-4">Start your
          movie journey by
          creating a personalized account on our platform.
        </p>
      </div>
      <div
        class="flex flex-col items-start  border-2 border-base-100 p-5 rounded-3xl transition-all duration-200 ease-in-out hover:bg-base-100">
        <p class="text-[30px] text-primary font-bold mb-4">02</p>
        <p class="text-[20px] font-bold text-accent mb-4">Choose Your Plan</p>
        <p class="text-[18px]  text-neutral-400 mb-4">Select first plan then pay for it
          and enjoy available tvShows within your plan
        </p>
      </div>

      <div
        class="flex flex-col items-start  border-2 border-base-100 p-5 rounded-3xl transition-all duration-200 ease-in-out hover:bg-base-100">
        <p class="text-[30px] text-primary font-bold mb-4">03</p>
        <p class="text-[20px] font-bold text-accent mb-4">Enjoy Our Services</p>
        <p class="text-[18px]  text-neutral-400 mb-4">Watch movies,series,Tv Shows within your permissions.
        </p>
      </div>


    </div>
  </div>
</div>

